<template>
    <div class="nerby-shops">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <ul>
                <li class="shop-item">
                    <div class="shops-top">
                        <div class="shop-img">
                            <img src="../../assets/img/logo.png" alt="">
                        </div>
                    </div>
                    <div class="shops-right">
                        <div class="shops-name-adress">
                            <p class="shops-name">森马官方旗舰店</p>
                            <p class="shops-adress">河南省/安阳市/滑县/道口镇</p>    
                        </div>
                        <div class="shops-btn">
                            <div class="btn-border">
                                导航
                            </div>
                            <div class="btn-border">
                                <a href="tel:13523039391">电话</a>
                            </div>
                            <div class="btn-background">
                                进入店铺
                            </div>
                        </div>
                    </div>
                </li>
                <li class="shop-item">
                    <div class="shops-top">
                        <div class="shop-img">
                            <img src="../../assets/img/logo.png" alt="">
                        </div>
                    </div>
                    <div class="shops-right">
                        <div class="shops-name-adress">
                            <p class="shops-name">森马官方旗舰店</p>
                            <p class="shops-adress">河南省/安阳市/滑县/道口镇</p>    
                        </div>
                        <div class="shops-btn">
                            <div class="btn-border">
                                导航
                            </div>
                            <div class="btn-border">
                                <a href="tel:13523039391">电话</a>
                            </div>
                            <div class="btn-background">
                                进入店铺
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </van-list>
            <!-- <ul>
            <li class="shop-item">
                <div class="shops-top">
                    <div class="shop-img">
                        <img src="../../assets/img/logo.png" alt="">
                    </div>
                </div>
                <div class="shops-right">
                    <div class="shops-name-adress">
                        <p class="shops-name">森马官方旗舰店</p>
                        <p class="shops-adress">河南省/安阳市/滑县/道口镇</p>    
                    </div>
                    <div class="shops-btn">
                        <div class="btn-border">
                            导航
                        </div>
                        <div class="btn-border">
                            电话
                        </div>
                        <div class="btn-background">
                            进入店铺
                        </div>
                    </div>
                </div>
            </li>
        </ul> -->
    </div>
</template>
<script>
    export default {
        data() {
            return {
                loading: false,
                finished: true
            }
        },
        methods:{
            onLoad(){},
        }
    }
</script>
<style scoped>
    .nerby-shops {
        background: #F5F5F5;
    }

    .shop-item {
        width: 714px;
        height: 234px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        overflow: hidden;
        margin: 0 auto 20px;
        display: flex;
        text-align: left;
    }

    .shop-img {
        background-color: #f5f5f5;
        width: 104px;
        height: 104px;
        border-radius: 4px;
        overflow: hidden;
        text-align: center;
        line-height: 104px;
        margin-top: 30px;
        margin-left: 30px;
        margin-right: 30px;
    }

    .shop-img img {
        width: 100%;
    }

    .shops-name-adress {
        height: 104px;
        overflow: hidden;
        margin-bottom: 20px;
        width: 100%;
        padding-right: 30px;
        margin-top: 30px;
    }

    .shops-name {
        font-size: 28px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        line-height: 40px;
    }

    .shops-adress {
        font-size: 26px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 37px;
    }

    .shops-btn {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .btn-border {
        width: 130px;
        height: 50px;
        background: rgba(255, 255, 255, 1);
        border-radius: 25px;
        border: 1px solid rgba(255, 85, 7, 1);
        font-size: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(255, 85, 7, 1);
        line-height: 30px;
        text-align: center;
        margin-right: 58px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .btn-border a{
        color: rgba(255, 85, 7, 1);
    }
    .btn-background {
        width: 130px;
        height: 50px;
        background: linear-gradient(90deg, rgba(254, 135, 2, 1) 0%, rgba(255, 16, 0, 1) 100%);
        border-radius: 25px;
        font-size: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>